// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-GDyZ","blur":"styles_blur__KFKZq","Animation":"styles_Animation__xmeDw","border":"styles_border__RgUwp","reverse":"styles_reverse__A7REu"};